module.exports = __webpack_public_path__ + "static/media/190x190px_tidsbokning_grey.93d64788.png";